import { Project } from '@/dashboard/types/project';

export function isUserInProject(project: Project, userId: number): boolean {
  return (project?.users ?? []).map((item) => item.id).includes(userId);
}
